/**
 * Created by ganlu on 28/03/2017.
 */
class CareerController {
    constructor ($state) {
        "ngInject";

        this.tabs = [
            {
                name: '原本简介',
                click: () => {
                    $state.go('app.page.career.intro');
                },
                active: $state.is('app.page.career.intro')
            },
            {
                name: '区块链',
                click: () => {
                    $state.go('app.page.career.algorithms');
                },
                active: $state.is('app.page.career.algorithms')
            },
            {
                name: '人工智能',
                click: () => {
                    $state.go('app.page.career.ai');
                },
                active: $state.is('app.page.career.ai')
            },
          {
            name: '客户端',
            click: () => {
              $state.go('app.page.career.developers');
            },
            active: $state.is('app.page.career.developers')
          },
          {
            name: '系统开发',
            click: () => {
              $state.go('app.page.career.system');
            },
            active: $state.is('app.page.career.system')
          },
            {
                name: '产品运营',
                click: () => {
                    $state.go('app.page.career.products');
                },
                active: $state.is('app.page.career.products')
            },
            {
                name: 'UI设计',
                click: () => {
                    $state.go('app.page.career.uiDesign');
                },
                active: $state.is('app.page.career.uiDesign')
            },
            {
                name: '行政主管',
                click: () => {
                    $state.go('app.page.career.administrative');
                },
                active: $state.is('app.page.career.administrative')
            }
        ];
    }
}

export default CareerController;



// WEBPACK FOOTER //
// ./src/app/components/page/career/career.controller.js